import { IContainer } from '../../interface/container';
import authApiInst from '../impl/auth.bind';
import mediaDiffApiInst from '../impl/mediaDiff.bind';
import mediaApiInst from '../impl/mediaVTS.bind';
import siteDataApiInst from '../impl/siteData.bind';
import {
    bindAuthAPI,
    bindMediaAPI,
    bindMediaDiffAPI,
    bindSiteDataAPI,
    injectAuthAPI,
    injectMediaAPI,
    injectMediaDiffAPI,
    injectSiteDataAPI,
    unbindAuthAPI,
    unbindMediaAPI,
    unbindMediaDiffAPI,
    unbindSiteDataAPI,
} from '../interface/bind';

function bind(container: IContainer) {
    /* find existing mediaAPIs & append */
    const mediaAPIs = injectMediaAPI(container) ?? [];
    bindMediaAPI([...mediaAPIs, mediaApiInst(container)], container);

    bindAuthAPI(authApiInst(container), container);
    bindMediaDiffAPI(mediaDiffApiInst(container), container);
    bindSiteDataAPI(siteDataApiInst(container), container);
}

function unbind(container: IContainer) {
    unbindMediaAPI(container);
    unbindAuthAPI(container);
    unbindMediaDiffAPI(container);
    unbindSiteDataAPI(container);
}

function expose(srcContainer: IContainer, dstContainer: IContainer) {
    bindMediaAPI(injectMediaAPI(srcContainer), dstContainer);
    bindAuthAPI(injectAuthAPI(srcContainer), dstContainer);
    bindMediaDiffAPI(injectMediaDiffAPI(srcContainer), dstContainer);
    bindSiteDataAPI(injectSiteDataAPI(srcContainer), dstContainer);
}

const module = {
    bind,
    unbind,
    expose,
};

export default module;
